<template>
  <tr>
    <td class="col-width">
      <a target="_blank" :href="noteLink">
        <TooltipEllipses :value="id" />
      </a>
    </td>
    <td class="col-width">
      <TooltipEllipses :value="title" />
    </td>
    <td class="col-width">
      <span>{{ typeLabel }}</span>
    </td>
    <td class="col-width" v-if="textNoteCategories">{{ categoryLabel }}</td>
    <td>
      <TooltipEllipses :value="author" />
    </td>
    <td class="col-width">{{ formattedDate(updatedAt) }}</td>
    <td class="col-width">{{ draftStatus }}</td>
    <td class="col-width">{{ externalStatus }}</td>
    <td class="col-width">
      <div v-if="isPublisher">
        <a href v-if="isDraft" @click.prevent.stop="publish(textNote)">Publier</a>
        <a href v-if="isPublishRequested" @click.prevent.stop="cancelPublish(textNote)"
          >Annuler la demande de publication</a
        >
        <a href v-if="isPublished" @click.prevent.stop="unpublish(textNote)">Dépublier</a>
        <a href v-if="isUnPublishRequested" @click.prevent.stop="cancelUnpublish(textNote)"
          >Annuler la demande de dépublication</a
        >
      </div>
    </td>
  </tr>
</template>
<script>
import { mapActions } from 'vuex';
import { noteLink } from '../util/index';
import { text_notes_categories } from 'config';
import TooltipEllipses from './TooltipEllipses.vue';
import abilitiesMixin from 'mixins/abilitiesMixin.js';
import dayjs from 'dayjs';

export default {
  name: 'TextNoteRow',
  props: {
    textNote: Object,
    textNoteCategories: Boolean,
  },
  mixins: [abilitiesMixin],
  components: {
    TooltipEllipses,
  },
  computed: {
    userId() {
      return this.textNote.user_id;
    },
    noteLink() {
      return noteLink(this.textNote);
    },
    properties() {
      return this.textNote.note_properties;
    },
    title() {
      return this.properties.title;
    },
    type() {
      return this.properties.type;
    },
    author() {
      return this.properties.author;
    },
    id() {
      return this.textNote.id;
    },
    isDraft() {
      return this.textNote.status === 'draft';
    },
    isPublished() {
      return this.textNote.status === 'published';
    },
    isExternal() {
      return this.textNote.external_id;
    },
    isPublishRequested() {
      return this.textNote.status === 'publish_requested';
    },
    isUnPublishRequested() {
      return this.textNote.status === 'unpublish_requested';
    },
    externalStatus() {
      if (this.isDraft && this.isExternal) return 'Modification en cours';
      if (this.isPublishRequested) return 'En attente de publication';
      if (this.isUnPublishRequested) return 'En attente de dépublication';
    },
    typeLabel() {
      if (this.type === 'cart') return this.$gettext('Thématique');
      if (this.type === 'artist') return this.$gettext('Artiste');
      if (this.type === 'artwork') return this.$gettext('Œuvre(s)');
      if (this.type === 'movement') return this.$gettext('Mouvement');
    },
    draftStatus() {
      return this.isExternal ? this.$gettext('oui') : '';
    },
    categoryLabel() {
      let categoryId = this.properties.category;
      if (!categoryId || typeof categoryId === 'undefined') {
        return;
      }

      let category = text_notes_categories.filter((c) => {
        return c.id === categoryId;
      })[0];

      return category ? category.label : '';
    },
    isPublisher() {
      return this.isInternal && this.$can('publish_all', 'text_note');
    },
    isInternal() {
      return this.textNote.internal;
    },
    updatedAt() {
      return this.textNote.updated_at;
    },
  },
  methods: {
    ...mapActions('textNotes', ['publish', 'cancelPublish', 'unpublish', 'cancelUnpublish']),
    formattedDate(date) {
      return dayjs(date).format('DD/MM/YYYY');
    },
  },
};
</script>
>
